import SHA256 from 'crypto-js/sha256';

import { removeGivenTextFromString } from '@bedrock-rdk/utils/src/string';
import {
  RESTORE_DEVICE_DATA,
  SET_USER_CONSENTS,
  GENERATE_DEVICE_ID,
  UPDATE_DEVICE_ID,
  SYNCHRONIZE_USER_CONSENTS,
  CALL_GEO_SUCCESS,
  SET_USER_UID,
  USER_FETCH_LAST_CLIPS_SUCCESS,
  FETCH_PROFILE_INFOS_SUCCESS,
  PARENTAL_LOCK_STATUS,
  PARING_SET_PREVIOUS_PROFILE_UID,
  SET_ACCOUNT_COMPLETE,
} from './user.actions';
import { RENEW_TOKEN_SUCCESS } from '../pairing/pairing.actions';
import { formatClipsObject, prefixWithHomeId } from './user.utils';
import { areCookiesEmpty } from '../gdprNotice/gdprNotice.utils';
import { CONFIG_INIT } from '../app/app.config.actions';
import { PAIRING_RESET } from '../pairing/unpair.actions';

export const initialState = {
  accountComplete: false,
  cookies: {},
  areUserPreferencesSet: false,
  deviceId: null,
  homeId: null,
  synchronize: false,
  localDeviceId: null,
  localHomeId: null,
  uid: null,
  profileUid: null,
  geo: null,
  lastClips: {},
  profileAvatarId: null,
  profileUsername: null,
  parentalLockStatus: null,
  previousProfileUid: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CONFIG_INIT: {
      const { cookies } = action;

      return {
        ...state,
        cookies,
        areUserPreferencesSet: !areCookiesEmpty(cookies),
      };
    }
    case RESTORE_DEVICE_DATA: {
      const { deviceId, homeId, synchronize } = action;

      return {
        ...state,
        deviceId,
        homeId: prefixWithHomeId(homeId),
        localDeviceId: removeGivenTextFromString(deviceId, 'deviceid-'),
        localHomeId: homeId,
        synchronize,
      };
    }
    case SET_USER_CONSENTS: {
      const { type, ...cookies } = action;

      return {
        ...state,
        cookies,
        areUserPreferencesSet: true,
        synchronize: false,
      };
    }
    case GENERATE_DEVICE_ID: {
      return {
        ...state,
        deviceId: action.deviceId,
        localDeviceId: removeGivenTextFromString(action.deviceId, 'deviceid-'),
      };
    }
    case UPDATE_DEVICE_ID: {
      return {
        ...state,
        deviceId: action.deviceId,
        localDeviceId: removeGivenTextFromString(action.deviceId, 'deviceid-'),
        synchronize: false,
      };
    }
    case SYNCHRONIZE_USER_CONSENTS: {
      return {
        ...state,
        synchronize: true,
      };
    }
    case CALL_GEO_SUCCESS: {
      const { ip } = action.data;

      return {
        ...state,
        geo: {
          ...action.data,
          hashIp: SHA256(ip).toString(),
        },
      };
    }
    case SET_USER_UID: {
      return {
        ...state,
        uid: action.uid,
      };
    }
    case USER_FETCH_LAST_CLIPS_SUCCESS:
      return {
        ...state,
        lastClips: formatClipsObject(action.lastClips),
      };
    case FETCH_PROFILE_INFOS_SUCCESS:
      return {
        ...state,
        profileAvatarId: action.profileAvatarId,
        profileUsername: action.username,
        isKidsProfile: action.isKidsProfile,
      };
    case RENEW_TOKEN_SUCCESS:
      return {
        ...state,
        profileUid: action.profileUid,
      };
    case PARENTAL_LOCK_STATUS:
      return {
        ...state,
        parentalLockStatus: action.isUnlocked,
      };
    case PARING_SET_PREVIOUS_PROFILE_UID:
      return {
        ...state,
        previousProfileUid: action.previousProfileUid,
      };
    case SET_ACCOUNT_COMPLETE: {
      return {
        ...state,
        accountComplete: true,
      };
    }
    case PAIRING_RESET: {
      return {
        ...initialState,
        cookies: state.cookies || {},
      };
    }
    default:
      return state;
  }
};
